import { DefaultZIndexes } from 'recharts';

// Reserve the former axis gutter for the plot while retaining the released
// legend box, which Recharts otherwise derives from the enlarged margins.
export const DEFAULT_Y_AXIS_WIDTH = 60;
export const ANALYSIS_CHART_LEFT_MARGIN = 50;
export const ANALYSIS_CHART_RIGHT_MARGIN = 90;
/** Empty strip after the last date where the alert labels sit, clear of the data. */
export const TEMP_HUMIDITY_ALERT_LABEL_STRIP_PX = 110;
export const RUNTIME_CHART_RIGHT_MARGIN = ANALYSIS_CHART_RIGHT_MARGIN + DEFAULT_Y_AXIS_WIDTH;
export const ANALYSIS_LEGEND_WRAPPER_STYLE = {
  left: ANALYSIS_CHART_LEFT_MARGIN,
  width: `calc(100% - ${ANALYSIS_CHART_LEFT_MARGIN + ANALYSIS_CHART_RIGHT_MARGIN}px)`,
};

// Recharts 3 paints axes above bars by default, muting bars at the plot floor.
export const RUNTIME_SERIES_Z_INDEX = DefaultZIndexes.scatter;
